"use strict";

exports.__esModule = true;
exports.Device = Device;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _FilterDeviceListContext = require("../../Filters/FilterDeviceListContext");
var _PlantTwinContext = require("../PlantTwinContext");
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SelectionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Device__SelectionWrapper",
  componentId: "sc-f65yj8-0"
})(["display:flex;flex-direction:row;.", "{margin:auto;width:12px;height:12px;box-shadow:inset 0 0 0 1px rgba(16,22,26,0.4),inset 0 -1px 0 rgba(16,22,26,0.2);background-color:", ";background-image:linear-gradient( to bottom,rgba(255,255,255,0.1),rgba(255,255,255,0) );display:flex;align-items:center;justify-content:center;border-radius:3px;font-size:12px;.", "{color:#ffffff;}margin-right:5px;}"], _core.Classes.CONTROL_INDICATOR, (0, _Theme.val)("bp6-intent-primary"), _core.Classes.ICON);
var DeviceWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Device__DeviceWrapper",
  componentId: "sc-f65yj8-1"
})(["opacity:", ";font-size:", ";color:", ";font-weight:", ";"], function (props) {
  return props.isEnabled ? 1 : 0.2;
}, function (props) {
  return props.fontSize || props.theme.fontSizeLarge;
}, function (props) {
  return props.fontColor || props.theme.linkColor;
}, function (props) {
  return props.fontWeight || "unset";
});
function Device(_ref) {
  var name = _ref.name,
    uuid = _ref.uuid,
    mode = _ref.mode,
    isEnabled = _ref.isEnabled,
    fontSize = _ref.fontSize,
    fontColor = _ref.fontColor,
    fontWeight = _ref.fontWeight;
  var _React$useContext = _react["default"].useContext(_FilterDeviceListContext.FilterDeviceListContext),
    selectedDevices = _React$useContext.selectedDevices,
    onDeviceSelect = _React$useContext.onDeviceSelect;
  var deviceHierarchy = _react["default"].useContext(_PlantTwinContext.PlantTwinContext);
  var device = /*#__PURE__*/_react["default"].createElement(DeviceWrapper, {
    isEnabled: isEnabled,
    fontSize: fontSize,
    fontColor: fontColor,
    fontWeight: fontWeight
  }, name || uuid);
  if (mode === "edit") {
    return device;
  }
  function onCheckboxClick() {
    return function () {
      var children = deviceHierarchy.devices.filter(function (device) {
        return device.path.match(new RegExp(uuid, "gi"));
      }).map(function (device) {
        return device.uuid;
      });
      if (selectedDevices.includes(uuid)) {
        onDeviceSelect(selectedDevices.filter(function (device) {
          return !children.includes(device);
        }));
      } else {
        var updatedSelection = selectedDevices.concat(children).reduce(function (acc, device) {
          if (!acc[device]) {
            acc[device] = device;
          }
          return acc;
        }, {});

        // $FlowIgnore
        onDeviceSelect(Object.values(updatedSelection));
      }
    };
  }
  if (mode === "selection") {
    return /*#__PURE__*/_react["default"].createElement(SelectionWrapper, null, /*#__PURE__*/_react["default"].createElement("span", {
      role: "presentation",
      className: _core.Classes.CONTROL_INDICATOR,
      onClick: onCheckboxClick()
    }, selectedDevices.includes(uuid) ? /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.SMALL_TICK
    }) : /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.BLANK
    })), device);
  }
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    "data-testid": "PlantTwinTreeView.Device." + uuid,
    to: "/plant-twin/" + uuid + "/update"
  }, device);
}